<template>
  <div class="search-widget">
    <img
      v-if="icon == 'left'"
      src="@/assets/images/icons/search.svg"
      class="search-icon left"
      alt=""
    />
    <input
      :type="type"
      :disabled="disabled"
      :value="value"
      :placeholder="placeholder"
      class="widget_search-input"
      @change="onChange"
      @blur="onBlur"
      @focus="onFocus"
      @keyup="onKeyup"
      @keydown="onKeydown"
      @click="onClick"
    />
    <img
      v-if="icon == 'right'"
      src="@/assets/images/icons/search.svg"
      class="search-icon right"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "widget_search",
  props: {
    icon: {
      type: String,
      default: "left",
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("change", e);
    },
    onBlur(e) {
      let vm = this;
      vm.$emit("blur", e);
    },
    onFocus(e) {
      let vm = this;
      vm.$emit("focus", e);
    },
    onKeyup(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onKeydown(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.search-widget {
  border: 1px solid #c3cad9;
  display: flex;
  padding: 14px 10px;
  border-radius: 5px;
  .search-icon {
    width: 20px;
    &.left {
      margin-right: 10px;
    }
    &.right {
      margin-left: 10px;
    }
  }
  .widget_search-input {
    font-weight: 500;
    width: 100%;
    position: relative;
    background: transparent;
    outline: none;
    border: none;
  }
}
</style>
